export const BPA_INITIAL_PAGE_SIZE = 25;
export const BPA_LOAD_MORE_PAGE_SIZE = 200;

export type BpaRequestMode = "initial" | "more" | "all";

export function nextBpaRequest(input: {
  loaded: number;
  total: number | null;
  mode: BpaRequestMode;
}): { limit: number; offset: number } | null {
  const { loaded, total, mode } = input;

  if (mode === "initial") {
    return { limit: BPA_INITIAL_PAGE_SIZE, offset: 0 };
  }

  if (total !== null && loaded >= total) {
    return null;
  }

  if (mode === "all") {
    return { limit: (total as number) - loaded, offset: loaded };
  }

  const remaining = total !== null ? total - loaded : null;
  const limit =
    remaining !== null && remaining < BPA_LOAD_MORE_PAGE_SIZE ? remaining : BPA_LOAD_MORE_PAGE_SIZE;

  return { limit, offset: loaded };
}
